import React from 'react';
import {observer} from 'mobx-react-lite';
import {QuestionsForm} from '../../../../../src/components/CustomersBar/CustomerTab/MarketingTab/QuestionsForm';
import {useAppStateContext} from '../../../../../src/AppState/AppState';
import {QuestionAnswers} from '../../../../../src/components/CustomersBar/CustomerTab/MarketingTab/MarketingQuestion.state';
//@ts-expect-error
import ImmutablePropTypes from 'react-immutable-proptypes';
import Loading from '../../../../../src/components/Loading';

interface PropsType {
    status: string,
    errors: ImmutablePropTypes.map,
    customer: ImmutablePropTypes.map,
    onUpdateRequest: (id: number, data: {marketingQuestionsAnswers: QuestionAnswers}) => void
}

export const MarketingTab = observer((props: PropsType) => {

    const {promotionQuestionsState} = useAppStateContext();
    const {questions} = promotionQuestionsState;

    const {customer, onUpdateRequest, status, errors} = props;

    const customerId = customer.getIn(['data', 'id']);

    const marketingQuestionsAnswers = customer.getIn(['data', 'marketingQuestionsAnswers']);
    const answers = marketingQuestionsAnswers ? marketingQuestionsAnswers.toJS() : {};

    if (answers && questions.length) {
        return (<div>
            <QuestionsForm
                errors={errors}
                customerId={customerId}
                questions={questions}
                answers={answers}
                onUpdateRequest={onUpdateRequest}
            />
            <Loading active={ status === 'IN_PROGRESS' } message='Updating customer' />
        </div>);
    }

    return null;

});

